import React, { Component } from 'react';
import { Navigate, Link } from "react-router-dom";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import { VscFeedback } from "react-icons/vsc";
import axios from 'axios';

class Intro extends Component {

    settings = this.props.Settings;
    language = this.props.Language;

    state = {
        navigate: false,
        isLoading: false,
    }
    
    async componentDidMount() {
          
        // setTimeout(() => {
        //     this.setState({ logo: true });
        // }, 2000);

    }

    handleChange = lang => {
        this.props.handleLangaugeSubmit(lang);
        this.setState({ navigate : true});
    }


    render() {

        const { isLoading } = this.state;

        return (
            <>
            
                { this.state.navigate && <Navigate to="/menu" replace={true} /> }

                {
                    isLoading ? 
                    <div className='intro'>
                            <div className="head">
                                <SkeletonTheme  baseColor="#FFFFFF12" highlightColor="#135B3C" >
                                    <Skeleton height={150} width={150} circle={true} containerClassName="flex-1" />
                                </SkeletonTheme>
                            </div>

                            <SkeletonTheme  baseColor="#FFFFFF12" highlightColor="#135B3C" >
                                <Skeleton height={200} containerClassName="flex-1" />
                            </SkeletonTheme>

                            <SkeletonTheme  baseColor="#FFFFFF12" highlightColor="#135B3C" >
                                <Skeleton height={200} containerClassName="flex-1" />
                            </SkeletonTheme>
                        
                    </div>
                    : 
                    <div className='intro' style={ { backgroundImage :`url(${this.settings.introCover})`, backgroundSize: 'cover', backgroundOrigin: 'bottom' } } >
                    <div className="head">
                        <div className='send-feedback'>
                            <Link to={"/feedback"}>
                                <VscFeedback /> <span>Feedback</span> 
                            </Link>
                        </div>
                        <img src={this.settings.logo} alt="" />
                        {/* <h3>{this.settings.name}</h3> */}
                    </div>

                    <div className="info">

                        <div className="social">

                            { 
                                this.settings.instgram 
                                &&
                                <a href={this.settings.instgram}><i className="fa-brands fa-instagram"></i></a>
                            }

                            { 
                                this.settings.snapchat
                                &&
                                <a href={this.settings.snapchat}><i className="fa-brands fa-snapchat"></i></a>
                            }

                            { 
                                this.settings.facebook
                                &&
                                <a href={this.settings.facebook}><i className="fa-brands fa-square-facebook"></i></a>
                            }

                            { 
                                this.settings.titok
                                &&
                                <a href={this.settings.titok}><i className="fa-brands fa-tiktok"></i></a>
                            }

                        </div>
                    </div>


                    <div className={`form`}>
                        <button className={`intro-hidden-lang-0`} onClick={() => this.handleChange('krd')} > کوردی </button>
                        <div className='langBtnContainer'>
                            <div>
                                <button className={`intro-hidden-lang-1`} onClick={() => this.handleChange('en')}> English </button>
                            </div>
                            <div>
                                <button className={`intro-hidden-lang-2`} onClick={() => this.handleChange('ar')}> عربي </button>
                            </div>
                        </div>
                    </div>

                    <div className="footer">
                        Powered By <a href='https://www.instagram.com/caviar.menu/' className='caviar'>Caviar Menu</a>
                    </div>


                </div>

                }

               
            </>
        );
    }
}

export default Intro;